// import { Avatar } from "@material-ui/core";
import React from "react";
import "../style/about.css";
function About() {
  return (
    <>
      <div className="aboutMainDiv">
        <div className="container pt-5 pb-5">
          <div className="row pt-5">
            <div className="col-md-3 co-12 ">
              <div className="myPhotoDiv">
                <img
                  src={process.env.PUBLIC_URL + "/images/myPhoto.jpeg"}
                  className="myPhoto"
                  alt="shivaji kumar the mern stack developer"
                />
              </div>
            </div>

            <div className="col-md-9 col-12">
              <div className="aboutText text-white pt-5">
                <h2>About Me</h2>
                <p style={{ color: "#7A7A7A" }}>
                  My name is Shivaji Kumar, I'm a self-taught MERN Stack and
                  React Native Developer. Currently i am doing my B.Tech In
                  Computor Science And Expanding my skills. I am also a
                  freelancer on fiverr and many other platforms.
                </p>

                <h2 className="mt-5">Contact Details</h2>
                <p style={{ color: "#7A7A7A" }}>
                  IIITM Gwalior, MP. <br />
                  Mob : 8295850524 <br />
                  Email : official.shivaji007@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
